import { Controller } from "@hotwired/stimulus"

// Polls while extraction runs, then reloads once so the reconciliation screen renders
// server-side. Polling rather than a socket: a preparer often leaves the tab and comes
// back, and a plain GET survives that without any reconnect logic.
export default class extends Controller {
  static targets = ["bar", "label"]
  static values = { url: String, interval: { type: Number, default: 2500 } }

  connect() {
    this.timer = setInterval(() => this.#poll(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async #poll() {
    let payload
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      payload = await response.json()
    } catch {
      return // a dropped request just means we try again on the next tick
    }

    if (this.hasBarTarget) this.barTarget.style.width = `${payload.percentage}%`
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = payload.asset_count > 0
        ? `${payload.percentage}% — ${payload.asset_count} assets so far`
        : `${payload.percentage}%`
    }

    if (payload.status !== "pending" && payload.status !== "processing") {
      clearInterval(this.timer)
      window.location.reload()
    }
  }
}
